(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-interactive"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-interactive"] = factory(root["mggp-player"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__383__) => {
return 